import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import {
  MigrationState,
  IAccountMigration,
  IMigrationStatus,
  IMigration,
} from '@shared';
import { MigrationsService } from '../../services/migrations.service';
import { FormControl } from '@angular/forms';
import { startWith, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'migrations-account',
  templateUrl: './migrations-account.component.html',
  styleUrls: ['./migrations-account.component.scss'],
})
export class MigrationsAccountComponent implements OnInit, OnDestroy {
  @Input() isLoadingMigrations: boolean;
  @Input() progressIsLoading: boolean;
  @Input() migrations: IAccountMigration[];
  @Input() progress: IMigrationStatus;
  @Input() pasProgressIsLoading: boolean;
  @Input() pasMigrationsProgress: IMigration;

  @Output() changeChartPeriod = new EventEmitter<string>();
  @Output() openMigrationModal = new EventEmitter<IMigration>();
  @Output() getMigrationReport = new EventEmitter<IMigration>();
  @Output() updateMigrationProgress = new EventEmitter<{
    proAccountId: string;
    oneAccountId: string;
    sectionId: string;
  }>();

  period = new FormControl('3');

  period$ = this.period.valueChanges.pipe(shareReplay(1), startWith('3'));

  onDestroy$ = new Subject();
  MigrationState = MigrationState;

  constructor(private migrationsService: MigrationsService) {
    this.period$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((value) => {
          this.changeChartPeriod.emit(value);
        }),
      )
      .subscribe();
  }

  ngOnInit() {}

  getMigrationStateClass(state: MigrationState) {
    return this.migrationsService.getMigrationStateClass(state);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }

  copyLogGroupUrl(logStreamUrl: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = logStreamUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  openInNewTab(url: string) {
    window.open(url);
  }
}
